import { useCallback, useEffect, useRef, useState } from 'react';
import { siteApi } from './siteApi';

export const useAdminAccessPolicy = (active = true) => {
  const [required, setRequired] = useState(null), [error, setError] = useState('');
  const request = useRef(null);
  const reload = useCallback(async () => {
    request.current?.abort();
    const controller = new AbortController(); request.current = controller;
    setError('');
    try {
      const data = await siteApi('/admin/access-policy', { signal: controller.signal });
      if (typeof data.master_password_required !== 'boolean') throw new Error('Unable to verify administrator access.');
      if (!controller.signal.aborted) setRequired(data.master_password_required);
    } catch (failure) {
      if (!controller.signal.aborted) { setRequired(null); setError(failure.message); }
    }
  }, []);
  useEffect(() => {
    if (!active) return;
    reload();
    window.addEventListener('focus', reload);
    return () => { request.current?.abort(); window.removeEventListener('focus', reload); };
  }, [active, reload]);
  return { required, error, reload };
};